import { RefObject, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router';

export const useLogRootViewHtml = (rootRef: RefObject<HTMLElement | null>) => {
  const location = useLocation();
  const [textContent, setTextContent] = useState('');
  useLayoutEffect(() => {
    const container = rootRef.current;

    if (!container) {
      return;
    }

    let timer: ReturnType<typeof setTimeout>;

    const schedule = () => {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        const text = (container.textContent ?? '').replace(/\s+/g, ' ').trim();
        setTextContent(prev => (prev !== text ? text : prev));
      }, 5000);
    };

    const mutationObserver = new MutationObserver(() => {
      schedule();
    });

    mutationObserver.observe(container, {
      childList: true,
    });

    schedule();

    return () => {
      if (timer) {
        clearTimeout(timer);
      }

      mutationObserver.disconnect();
    };
  }, [rootRef, location.key]);

  const reloadTrigger = () => {
    const container = rootRef.current;

    if (!container) {
      return;
    }

    const text = (container.textContent ?? '').replace(/\s+/g, ' ').trim();
    setTextContent(prev => (prev !== text ? text : prev));
  };

  return { textContent, reloadTrigger };
};
